import { render, staticRenderFns } from "./OurWarningsTooltip.vue?vue&type=template&id=00cd0a0d&"
import script from "./OurWarningsTooltip.vue?vue&type=script&lang=js&"
export * from "./OurWarningsTooltip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports